import { memo } from "react"

export const AccordionIcon = memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H7C6.44772 6 6 5.55228 6 5Z"
        fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29289 9.29289C8.68342 8.90237 9.31658 8.90237 9.70711 9.29289L12 11.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L12.7071 13.7071C12.3166 14.0976 11.6834 14.0976 11.2929 13.7071L8.29289 10.7071C7.90237 10.3166 7.90237 9.68342 8.29289 9.29289Z"
        fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 17C5 16.4477 5.44772 16 6 16H18C18.5523 16 19 16.4477 19 17C19 17.5523 18.5523 18 18 18H6C5.44772 18 5 17.5523 5 17Z"
        fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 20C5 19.4477 5.44772 19 6 19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H6C5.44772 21 5 20.5523 5 20Z"
        fill="currentColor" />
    </svg>
  );
})

AccordionIcon.displayName = "AccordionIcon"
